import { useEffect, useMemo, useCallback } from 'react';
import moment from 'moment';
import 'moment-timezone';
import { useTranslation } from 'react-i18next';
import 'moment/dist/locale/ja';
import 'moment/dist/locale/vi';
import 'moment/dist/locale/ko';
import 'moment/dist/locale/zh-tw';
import 'moment/dist/locale/zh-cn';
import 'moment/dist/locale/th';
import 'moment/dist/locale/id';

const useLocalizedTime = () => {
    const { i18n } = useTranslation();

    /**
     * i18nの言語とmomentのlocaleを結びつける
     */
    const localeDict: Record<string, string> = useMemo(
        () => ({
            ja: 'ja',
            en: 'en',
            vi: 'vi',
            ko: 'ko',
            'zh-TW': 'zh-tw',
            zh: 'zh-cn',
            th: 'th',
            id: 'id',
        }),
        [],
    );

    useEffect(() => {
        const locale = i18n.language;
        try {
            moment.locale(localeDict[locale]);
        } catch {
            moment.locale('en');
        }
    }, [i18n.language, localeDict]);

    /**
     * i18nで指定した言語でformatする。
     * @param {*} time 時刻情報
     * @param {string} format フォーマット形式
     * @returns
     */
    const formatTime = useCallback(
        (time: any, format: string) => {
            const locale = i18n.language;
            try {
                moment.locale(localeDict[locale]);
            } catch {
                moment.locale('en');
            }

            try {
                return moment(time).tz('Asia/Tokyo').format(format);
            } catch {
                return time;
            }
        },
        [i18n.language, localeDict],
    );

    return { formatTime };
};

export default useLocalizedTime;
